<template>
  <PartnersGrid :partners="partners">
  </PartnersGrid>
</template>

<script setup>
import PartnersGrid from "../PartnersGrid.vue";
import PartnersCard from "../PartnersCard.vue";

defineProps({
  partners: {
    type: Array,
    default: () => [],
  },
});

</script>

<style>
</style>
